import { css } from "@emotion/css";
import { SearchInput, useDebouncedCallback } from "@octopusdeploy/design-system-components";
import { useEffect } from "react";
import * as React from "react";
import { Skeleton } from "~/components/Skeleton/Skeleton";
interface ProjectDashboardSearchBoxProps {
    searchValue?: string;
    onSearchValueChange: (newValue: string) => void;
    placeholder?: string;
    debounceValue?: number;
}
export function ProjectsDashboardSearchBox({ searchValue, onSearchValueChange, placeholder, debounceValue }: ProjectDashboardSearchBoxProps) {
    const [internalSearchValue, setInternalSearchValue] = React.useState(searchValue ?? "");
    const debouncedOnSearchValueChange = useDebouncedCallback(() => onSearchValueChange(internalSearchValue), debounceValue ? debounceValue : 200);
    const placeholderText = placeholder ? placeholder : "Find projects or project groups";
    useEffect(() => {
        if (searchValue) {
            setInternalSearchValue(searchValue);
        }
    }, [searchValue]);
    const internalOnSearchValueChange = (newValue: string) => {
        setInternalSearchValue(newValue);
        if (newValue === "") {
            debouncedOnSearchValueChange.cancel();
            onSearchValueChange("");
        }
        else {
            debouncedOnSearchValueChange();
        }
    };
    return <SearchInput autoFocus={true} value={internalSearchValue} onChange={internalOnSearchValueChange} accessibleName={"search project or project group"} placeholder={placeholderText}/>;
}
export function ProjectsDashboardSearchBoxSkeleton() {
    return (<div className={searchInputSkeletonStyles}>
            <Skeleton shape={"Rounded"} borderRadius={"small"}/>
        </div>);
}
const searchInputSkeletonStyles = css({
    width: "19rem",
    height: "2.25rem",
});
